'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UILoading = require('UIComponents/loading/UILoading');

var _UILoading2 = _interopRequireDefault(_UILoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LoadingState() {
  return _react2.default.createElement(
    'div',
    { style: { height: '100%' } },
    _react2.default.createElement(_UILoading2.default, null)
  );
}

exports.default = LoadingState;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/LoadingState.js
// module id = 1035
// module chunks = 2 3